<template>
  <div v-if="notificationsIsEnabled">
    <v-menu
      v-model="showMenu"
      bottom
      offset-y
      transition="slide-y-transition"
      :close-on-click="false"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          overlap
          :content="unreadMessagesCount"
          :value="unreadMessagesCount"
          color="red"
          offset-x="15"
          offset-y="18"
          class="included"
        >
          <v-btn icon v-bind="attrs" v-on="on" @click="loadUnreadMessage(true)">
            <v-icon
              :color="color"
              class="pa-2"
            >mdi {{unreadMessagesCount ? 'mdi-bell-ring' : 'mdi-bell'}}</v-icon>
          </v-btn>
        </v-badge>
      </template>

      <v-card width="400"
        v-click-outside="{ handler: onClickOutside, include }">
        <v-list-item two-line>
          <v-list-item-content class="text-center">
            <v-list-item-title>{{$t('notifications.notifications')}}</v-list-item-title>
            <v-list-item-subtitle
              v-html="$t('notifications.unseenCountText', {unreadMessagesCount})"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <div class="scroll-gradient">
          <div class="scroll-area">
            <v-list two-line dense >
              <notification-item
                v-for="item in messages"
                :key="item.id"
                :item="item"
                @itemClicked="onItemClicked"
                @markMessageAsRead="onMarkMessageAsRead"
              />
            </v-list>
          </div>
        </div>

        <v-card-actions>
          <v-tooltip bottom v-if="unreadMessages">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="onMarkAllMessagesAsRead">
                <v-icon>mdi-email-open</v-icon>
              </v-btn>
            </template>
            <span>{{$t('notifications.markAllSeen')}}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="openPanelWithAllMessages()">
                <v-icon v-if="showAllMessages">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <span>{{$t('notifications.showAll')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-dialog v-model="showDialog" max-width="500">
      <v-card>
        <v-card-title>{{dialogItem.Subject}}</v-card-title>
        <v-card-subtitle>
          {{$t('notifications.from')}} {{dialogItem.sender}}
          <br />
          {{timeToString(dialogItem.date, $i18n.locale)}}
        </v-card-subtitle>
        <v-card-text>
          <div class="text--primary" v-html="dialogItem.message"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { convertTimeToString } from '../tools/convertTimeToString'
import NotificationItem from './NotificationItem'
import { signalRApi } from '@/api/signalR'

export default {
  name: 'Notifications',
  components: { NotificationItem },
  props: ['color'],
  data: () => ({
    showMenu: false,
    showDialog: false,
    dialogItem: {},
    showAllMessages: false
  }),
  computed: {
    messages() {
      if (this.showAllMessages && this.allMessages.length) {
        return this.allMessages
      }
      return this.unreadMessages
    },
    allMessages() {
      return this.$notificationsCore.allMessages
    },
    unreadMessages() {
      return this.$notificationsCore.unreadMessages
    },
    unreadMessagesCount() {
      return this.$notificationsCore.unreadMessagesCount
    },
    notificationsIsEnabled() {
      return this.$notificationsCore.notificationsIsEnabled
    },
    userId() {
      return this.$store.state.auth.user.authData.id
    }
  },
  methods: {
    timeToString: convertTimeToString,
    //загрузка непрочитаных сообщений
    loadUnreadMessage(setShowMenu = false) {
      if (setShowMenu) {
        this.showMenu = true
      }
      this.$notificationsCore.fetchUnreadMessages(false)
    },
    // распахнуть панель со всеми сообщениями
    openPanelWithAllMessages() {
      this.$notificationsCore.fetchAllMessages(false)
      this.showAllMessages = !this.showAllMessages
    },
    onItemClicked(item) {
      this.dialogItem = item
      this.onMarkMessageAsRead(item)
      this.showDialog = true
    },
    // пометить все сообщения как прочитаны
    onMarkAllMessagesAsRead() {
      this.$notificationsCore.markAllMessagesAsRead()
    },
    // пометить сообщение как прочитано
    onMarkMessageAsRead(item) {
      this.$notificationsCore.markMessageAsRead(item)
    },
    onClickOutside () {
      this.showMenu = false
    },
    include () {
      const elemets = []
      if (document.querySelector('.included')) {
        elemets.push(document.querySelector('.included'))
      }
      if (document.querySelector('.v-overlay__scrim')) {
        elemets.push(document.querySelector('.v-overlay__scrim'))
      }
      if (document.querySelector('.v-dialog__content')) {
        elemets.push(document.querySelector('.v-dialog__content'))
      }
      return elemets
    }
  },
  beforeDestroy() {
    signalRApi.unsubscribe('WEB_APPLICATIONS_NOTIFICATIONS')
  },
  created() {
    if (!this.notificationsIsEnabled) {
      return
    }
    this.loadUnreadMessage()
    signalRApi.subscribe('WEB_APPLICATIONS_NOTIFICATIONS', function (message) {
      const args = JSON.parse(message)
      let currentUser = args.Recipients.find(x => x.toLocaleLowerCase() == this.userId.toLocaleLowerCase())
      if (currentUser) {
        this.loadUnreadMessage(false)
      }
    }.bind(this))
  }
}
</script>

<style lang="scss">
.scroll-area {
  max-height: 500px;
  overflow-x: hidden;
}
.scroll-gradient {
  position: relative;
  &:after,
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: auto;
    width: 100%;
    height: 20px;
    z-index: 10;
    background: linear-gradient(180deg, #fff 20%, hsla(0, 0%, 100%, 0));
  }
  &:after {
    top: auto;
    bottom: 0;
    background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 0, #fff 80%);
  }
}
</style>